import { useRef, useState, type CSSProperties, type ReactNode } from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

interface Props {
  /** tooltip 里显示的完整内容 */
  tip: ReactNode
  /** 应用在截断元素上的样式(组件自带单行省略,可被覆盖/追加) */
  style?: CSSProperties
  children: ReactNode
}

/**
 * 单行省略文本 + Hover Preview:只有内容真正被截断(scrollWidth > clientWidth)时,
 * hover 才弹出显示完整内容的 tooltip;未截断的短文本不弹。
 */
export function TruncateTip({ tip, style, children }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)

  return (
    <TooltipProvider delayDuration={250}>
      <Tooltip open={open} onOpenChange={(next) => {
        if (next && ref.current && ref.current.scrollWidth <= ref.current.clientWidth) return
        setOpen(next)
      }}>
        <TooltipTrigger asChild>
          <div ref={ref} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0, ...style }}>
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="start" style={{
          maxWidth: 400, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere',
          fontSize: 12.5, lineHeight: 1.5, padding: '8px 12px',
        }}>
          {tip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
